import React from 'react';
import { Link } from 'react-router-dom';
import BoGlyph from './BoGlyph';
import { SUPPORT_EMAIL } from '../config/site';

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer-inner">
      <div className="footer-row">
        <div className="brand footer-brand">
          {/* The one-colour glyph, in ember: the kung fu art's ink outline
              would vanish on the ink footer. */}
          <BoGlyph size={26} />
          <span>Bell Club</span>
          <span className="footer-year">© {new Date().getFullYear()}</span>
        </div>
        <nav className="footer-links" aria-label="Footer">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-service">Terms</Link>
          <Link to="/subprocessors">Subprocessors</Link>
          <Link to="/changelog">Changelog</Link>
          <a href={`mailto:${SUPPORT_EMAIL}`}>Support</a>
        </nav>
      </div>
      <p className="footer-fine">
        Bell Club is not medical advice. Apple, Apple Watch and Apple Health are trademarks of Apple
        Inc.
      </p>
    </div>
  </footer>
);

export default Footer;
